// import React from 'react';

// const BusRatesTable = () => {
//   const ratesData = [
    
//     { seater: "SWIFT DESIRE", mumbai: "4+1", mahabaleshwar: "12", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "AURA", mumbai: "4+1", mahabaleshwar: "12", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "TOYOTA ETIOS", mumbai: "4+1", mahabaleshwar: "14", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "ERITGA", mumbai: "6+1", mahabaleshwar: "15", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "INNOVA", mumbai: "6+1", mahabaleshwar: "18", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "SCORPIO", mumbai: "8+1", mahabaleshwar: "18", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "INNOVA CRYSTA", mumbai: "6+1", mahabaleshwar: "22", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "AUDI", mumbai: "4+1", mahabaleshwar: "ON CALL", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "TEMPO TRAVELLER", mumbai: "13/17 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "MINI BUS", mumbai: "20 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "BUS", mumbai: "32-52", mahabaleshwar: "ON CALL", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "TAVERA", mumbai: "8+1", mahabaleshwar: "18", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//     { seater: "KIA Carens", mumbai: "6+1/7+1", mahabaleshwar: "17/KM & 18/KM", specialPermitNumber: "919136271336", driver: "Including", parking: "Extra" },
//   ];

//   const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     margin: "20px auto",
//   };

//   const thStyle = {
//     backgroundColor: "#243547",
//     color: "white",
//     padding: "8px",
//     border: "1px solid #ddd",
//   };

//   const tdStyle = {
//     padding: "8px",
//     border: "1px solid #ddd",
//     textAlign: "center",
//   };

//   const trEvenStyle = {
//     backgroundColor: "#f2f2f2",
//   };

//   const handleWhatsAppClick = (number, seater) => {
//     console.log(`Opening WhatsApp for ${seater} with number ${number}`);
//     const message = `Hi, I would like to inquire about the rates for the ${seater}.`;
//     const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
//     window.open(url, '_blank');
//   };

//   return (
//     <div className="container p-0">
//       <h3>Rates for AC Buses</h3>
//       <div className="table-responsive">
//         <table style={tableStyle}>
//           <thead>
//             <tr>
//               <th style={thStyle}>Bus Name</th>
//               <th style={thStyle}>Seater</th>
//               <th style={thStyle}>Per KM</th>
//               <th style={thStyle}>Driver Food</th>
//               <th style={thStyle}>Toll Parking</th>
//               <th style={thStyle}>Book Now</th>
//             </tr>
//           </thead>
//           <tbody>
//             {ratesData.map((row, index) => (
//               <tr key={index} style={index % 2 === 0 ? trEvenStyle : null}>
//                 <td style={tdStyle}>{row.seater}</td>
//                 <td style={tdStyle}>{row.mumbai}</td>
//                 <td style={tdStyle}>{row.mahabaleshwar}</td>
//                 <td style={tdStyle}>{row.driver}</td>
//                 <td style={tdStyle}>{row.parking}</td>
//                 <td style={tdStyle}>
//                   <button
//                     onClick={() => handleWhatsAppClick(row.specialPermitNumber, row.seater)}
//                     style={{
//                       cursor: "pointer",
//                       backgroundColor: "#243547",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       color: "white",
//                     }}
//                   >
//                     Book Now
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>


//     </div>
//   );
// };

// export default BusRatesTable;


// import React from "react";

// const BusRatesTable = () => {
//   const ratesData = [
//     {
//       type: "🚗 Sedan (Dzire / Etios)",
//       capacity: "4+1",
//       oneWay: "₹2600",
//       roundTrip: "₹5500",
//       driver: "Including",
//       parking: "Including",
//       phone: "919136271336",
//     },
//     {
//       type: "🚙 SUV (Ertiga / Innova)",
//       capacity: "6+1",
//       oneWay: "₹3200",
//       roundTrip: "₹6500",
//       driver: "Including",
//       parking: "Including",
//       phone: "919136271336",
//     },
//     {
//       type: "🚘 Innova Crysta",
//       capacity: "6+1",
//       oneWay: "₹4500",
//       roundTrip: "₹7500",
//       driver: "Including",
//       parking: "Including",
//       phone: "919136271336",
//     },
//   ];

//   const handleWhatsAppClick = (number, vehicle) => {
//     const message = `Hi, I would like to inquire about the ${vehicle} rates.`;
//     const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
//     window.open(url, "_blank");
//   };

//   return (
//     <div style={{ padding: "30px", fontFamily: "Arial" }}>
//       <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
//         🚖 Car Rental Packages
//       </h2>

//       {/* TOP PRICING CARDS */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-around",
//           flexWrap: "wrap",
//           gap: "20px",
//           marginBottom: "30px",
//         }}
//       >
//         {ratesData.map((item, index) => (
//           <div
//             key={index}
//             style={{
//               flex: "1 1 250px",
//               border: "1px solid #ddd",
//               borderRadius: "10px",
//               padding: "20px",
//               textAlign: "center",
//               boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//             }}
//           >
//             <h3>{item.type}</h3>
//             <p style={{ fontSize: "18px", margin: "10px 0" }}>
//               ➡️ {item.oneWay} (One Way)
//             </p>
//             <p style={{ fontWeight: "bold" }}>
//               Round Trip: {item.roundTrip}
//             </p>
//           </div>
//         ))}
//       </div>

//       {/* TABLE */}
//       <div style={{ overflowX: "auto" }}>
//         <table
//           style={{
//             width: "100%",
//             borderCollapse: "collapse",
//             textAlign: "center",
//           }}
//         >
//           <thead>
//             <tr style={{ backgroundColor: "#243547", color: "white" }}>
//               <th style={th}>Vehicle Type</th>
//               <th style={th}>Capacity</th>
//               <th style={th}>One Way</th>
//               <th style={th}>Round Trip</th>
//               <th style={th}>Driver</th>
//               <th style={th}>Toll Parking</th>
//               <th style={th}>Book</th>
//             </tr>
//           </thead>

//           <tbody>
//             {ratesData.map((row, index) => (
//               <tr
//                 key={index}
//                 style={{
//                   backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
//                 }}
//               >
//                 <td style={td}>{row.type}</td>
//                 <td style={td}>{row.capacity}</td>
//                 <td style={td}>{row.oneWay}</td>
//                 <td style={td}>{row.roundTrip}</td>
//                 <td style={td}>{row.driver}</td>
//                 <td style={td}>{row.parking}</td>
//                 <td style={td}>
//                   <button
//                     onClick={() =>
//                       handleWhatsAppClick(row.phone, row.type)
//                     }
//                     style={{
//                       backgroundColor: "#243547",
//                       color: "#fff",
//                       padding: "8px 15px",
//                       border: "none",
//                       borderRadius: "6px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Book Now
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// const th = {
//   padding: "12px",
//   border: "1px solid #ddd",
// };

// const td = {
//   padding: "10px",
//   border: "1px solid #ddd",
// };

// export default BusRatesTable;











import React from "react";

const BusRatesTable = () => {

  const ratesData = [
    {
      seater: "SEDAN (Dzire / Etios)",
      capacity: "4+1",
      oneWay: "₹2600",
      roundTrip: "₹5500",
      driver: "Including",
      parking: "Including",
      number: "919136271336",
    },
    {
      seater: "SUV (Ertiga / Innova)",
      capacity: "6+1",
      oneWay: "₹3200",
      roundTrip: "₹6500",
      driver: "Including",
      parking: "Including",
      number: "919136271336",
    },
    {
      seater: "INNOVA CRYSTA",
      capacity: "6+1",
      oneWay: "₹4500",
      roundTrip: "₹7500",
      driver: "Including",
      parking: "Including",
      number: "919136271336",
    },
    {
      seater: "KIA CARENS",
      capacity: "6+1",
      oneWay: "₹4000",
      roundTrip: "₹7500",
      driver: "Including",
      parking: "Including",
      number: "919136271336",
    },
    {
      seater: "TAVERA / XYLO",
      capacity: "6+1",
      oneWay: "₹4500",
      roundTrip: "₹8000",
      driver: "Including",
      parking: "Including",
      number: "919136271336",
    },
    {
      seater: "TEMPO TRAVELLER (13 Seater)",
      capacity: "13 Seater",
      oneWay: "On Call",
      roundTrip: "On Call",
      driver: "Including",
      parking: "Including",
      number: "919136271336",
    },
  ];

  const handleWhatsAppClick = (number, seater) => {
    const message = `Hi, I would like to book ${seater}. Please share details.`;
    const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  };

  const thStyle = {
    backgroundColor: "#243547", // orange like screenshot
    color: "white",
    padding: "12px",
    border: "1px solid #ddd",
    fontWeight: "bold",
  };

  const tdStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontSize: "14px",
  };

  const trEvenStyle = {
    backgroundColor: "#f9f9f9",
  };

  const buttonStyle = {
    backgroundColor: "#243547",
    color: "white",
    padding: "10px 16px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  return (
    <div className="container">
      <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
        {/* 🚖 Cab Pricing Table */}
      </h2>

      <div className="table-responsive">
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Type of Vehicle</th>
              <th style={thStyle}>Capacity</th>
              <th style={thStyle}>One Way Price</th>
              <th style={thStyle}>Round Trip Price</th>
              <th style={thStyle}>Driver</th>
              <th style={thStyle}>Toll Parking</th>
              <th style={thStyle}>Book Now</th>
            </tr>
          </thead>

          <tbody>
            {ratesData.map((row, index) => (
              <tr key={index} style={index % 2 === 0 ? trEvenStyle : {}}>
                <td style={tdStyle}>{row.seater}</td>
                <td style={tdStyle}>{row.capacity}</td>
                <td style={tdStyle}>{row.oneWay}</td>
                <td style={tdStyle}>{row.roundTrip}</td>
                <td style={tdStyle}>{row.driver}</td>
                <td style={tdStyle}>{row.parking}</td>
                <td style={tdStyle}>
                  <button
                    style={buttonStyle}
                    onClick={() =>
                      handleWhatsAppClick(row.number, row.seater)
                    }
                  >
                    Book Now
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BusRatesTable;